import {Deal} from "@irati/types"
import basket from "@irati/checkout/utils/basket"
import getLimits from "@irati/deals/utils/deal/limits"

export function hitLimits(deal: Deal) {
  const {maxPrice, minPrice, numProducts, numItems} = getLimits(deal)

  const {total} = basket.breakdown
  const {items} = basket

  let reachedMinPrice = true
  if (minPrice !== null && items.length) {
    reachedMinPrice = total?.originalPrice ? total.originalPrice / 100 >= minPrice : false
  }

  let reachedMaxPrice = false
  if (maxPrice !== null && items.length) {
    reachedMaxPrice = total?.originalPrice ? total.originalPrice / 100 > maxPrice : false
  }

  const reachedMaxProducts = !!numProducts && numProducts !== 1 && items.length >= numProducts
  const reachedMaxItems =
    !!numItems &&
    numItems !== 1 &&
    items.reduce((runningTotal, current) => {
      return runningTotal + current.count!
    }, 0) >= numItems

  return {
    reachedMinPrice,
    reachedMaxPrice,
    reachedMaxProducts,
    reachedMaxItems
  }
}
